const { Core, onBlazeLoad } = Global;

customElements.define('slideshow-inline-blaze-loop', class extends Core {
  elements = {
    $: ['blaze', 'slides-wrapper', ['nav']]
  }

  propTypes = {
    gap: String,
    'slides-per-view': Number,
    'slides-per-view-mobile': Number,
    'preview-next-item': String,
    'slide-by-row': Boolean,
    'swipe-on-desktop': Boolean,
    'inert': Boolean
  }

  render() {
    if (this.prop('inert')) return;
    onBlazeLoad(this._initBlaze.bind(this));
  }

  destroy() {
    if (this.slider) {
      this.slider.destroy();
    }
  }

  replaceSlides(slides) {
    this.$('slides-wrapper').replaceChildren(...slides);
    this.reset();
  }

  reset() {
    if (!this.slider) {
      this.removeAttribute('inert');
      this._initBlaze();
      return;
    }

    this.slider.destroy();
    this._initBlaze();
  }

  _initBlaze() {
    if (!window.BlazeSlider) return;

    const configuredDesktopSlides = Number(this.prop('slides-per-view')) || 4;
    const configuredMobileSlides = Number(this.prop('slides-per-view-mobile')) || 1;
    const previewNextItem = String(this.getAttribute('preview-next-item')) === 'true';
    const totalSlides = this.$('slides-wrapper')?.children?.length || 0;

    const desktopSlidesToShow = this._getSlidesToShow({
      configuredSlides: configuredDesktopSlides,
      totalSlides,
      previewNextItem
    });

    const mobileSlidesToShow = this._getSlidesToShow({
      configuredSlides: configuredMobileSlides,
      totalSlides,
      previewNextItem
    });

    // IMPORTANT:
    // Update the CSS vars too, because the slider CSS uses them for layout.
    this.style.setProperty('--slides-per-view', desktopSlidesToShow);
    this.style.setProperty('--slides-per-view-mobile', mobileSlidesToShow);

    this.slider = new window.BlazeSlider(this.$('blaze'), {
      all: {
        slideGap: this.prop('gap'),
        loop: true,
        slidesToShow: desktopSlidesToShow,
        slidesToScroll: this.prop('slide-by-row') ? Math.max(1, Math.floor(configuredDesktopSlides)) : 1,
        draggable: this.prop('swipe-on-desktop')
      },
      '(max-width: 992px)': {
        loop: true,
        slidesToShow: mobileSlidesToShow,
        slidesToScroll: 1,
        draggable: true
      }
    });
  }

  _getSlidesToShow({ configuredSlides, totalSlides, previewNextItem }) {
    if (!previewNextItem) return configuredSlides;
    if (totalSlides <= configuredSlides) return configuredSlides;

    // Subtle preview of the next item
    return configuredSlides + 0.18;
  }
});